// extracted by mini-css-extract-plugin
export default {"toolBar":"AdminPTLTeam_toolBar__8O47n","adminTeam":"AdminPTLTeam_adminTeam__LFWj9","modal":"AdminPTLTeam_modal__bB9H2","modalContent":"AdminPTLTeam_modalContent__SF814"};